<template>
  <div>
    <div class="search-area" v-if="!currentFolder.id">
      <el-input
        v-model.trim="searchName"
        size="medium"
        maxlength="30"
        placeholder="请输入文件名"
      ></el-input>
      <button class="serarch-btn" @click="search">搜索</button>
      <button class="reset-btn" @click="reset" size="small">重置</button>
    </div>
    <div class="list">
      <!-- <el-breadcrumb separator-class="el-icon-arrow-right">
        <el-breadcrumb-item @click="goBack">首页</el-breadcrumb-item>
        <el-breadcrumb-item>活动管理</el-breadcrumb-item>
        <el-breadcrumb-item>活动列表</el-breadcrumb-item>
        <el-breadcrumb-item>活动详情</el-breadcrumb-item>
      </el-breadcrumb> -->
      <div class="breadcrumb-box">
        <span
          class="breadcrumb-item"
          v-for="(item, index) in levelPath"
          :key="item.id"
          @click="goBack(item, index)"
        >
          {{ item.name }}
          <i v-if="index < levelPath.length - 1" class="separate">/</i>
        </span>
      </div>
      <template v-if="fileList.length">
        <div
          class="file-item"
          v-for="item in fileList"
          :key="item.id"
          @click="nextLevel(item)"
        >
          <div class="img-box">
            <img :src="thumbnail(item)" alt="" />
          </div>
          <div class="info-box">
            <div class="name">{{ item.material_name }}{{ item.file_ext }}</div>
            <div v-if="!downloadingIds[item.id]" class="other-info">
              <span>{{ item.nick_name }}</span
              ><span class="divider"></span
              ><span>{{
                moment(item.created_at * 1000).format("YYYY-MM-DD")
              }}</span
              ><span class="divider" v-if="item.storage_type === 2"></span
              ><span v-if="item.storage_type === 2"
                >下载数：{{ item.download_num || 0 }}</span
              ><span class="divider" v-if="item.storage_type === 2"></span
              ><span v-if="item.storage_type === 2">
                {{ item.file_size | fileSizeFilter(item.storage_type) }}</span
              ><span
                class="divider"
                v-if="item.storage_type === 2 && item.pid"
              ></span
              ><span v-if="item.storage_type === 2 && item.pid">
                {{ item.pname }}</span
              >
            </div>
            <div v-if="downloadingIds[item.id]" class="other-info">
              <el-progress
                color="#2AB18A"
                :percentage="downloadProgress[item.id] || 0"
                :stroke-width="6"
                :width="50"
              ></el-progress>
            </div>
          </div>
          <div v-if="item.storage_type === 2 && !isElectron">
            <button class="download-btn" @click.stop="download(item)">
              下载
            </button>
          </div>
          <div v-if="item.storage_type === 2 && isElectron">
            <button
              class="download-btn"
              @click.stop="downloadElectron(item)"
              v-if="
                !currentDownloadedFileMap[item.material_name + item.file_ext]
              "
            >
              下载
            </button>
            <el-dropdown
              class="open-file-dropdown"
              split-button
              type="primary"
              size="small"
              v-else
              @command="handleCommand(item, $event)"
              @click.stop="open(item)"
            >
              打开
              <el-dropdown-menu slot="dropdown">
                <el-dropdown-item :command="1">打开</el-dropdown-item>
                <el-dropdown-item :command="2">打开文件夹</el-dropdown-item>
              </el-dropdown-menu>
            </el-dropdown>
          </div>
        </div>
      </template>

      <el-empty
        v-else
        description="暂无内容"
        :image="require('@/assets/img/live-list/empty.png')"
      ></el-empty>
    </div>
  </div>
</template>

<script>
import { getFileList, getFileSts } from "@saas/service-api/src/learning-center";
import { downloadFile } from "@saas/components/src/utils/cos-upload";
import moment from "moment";
export default {
  data() {
    return {
      folderPic: require("@saas/pages/assets/images/folder.png"),
      pptPic: require("@saas/pages/assets/images/ppt.png"),
      pdfPic: require("@saas/pages/assets/images/pdf.png"),
      docPic: require("@saas/pages/assets/images/doc.png"),
      xlsPic: require("@saas/pages/assets/images/xls.png"),
      txtPic: require("@saas/pages/assets/images/txt.png"),
      pageInfo: {
        page: 1,
        pageSize: 10,
      },
      searchName: "",
      fileList: [],
      levelPath: [{ id: 0, name: "课程文件" }],
      currentFolder: { id: 0, name: "课程文件" },
      moment: moment,
      noMore: false, //没有更多
      loading: false, //加载数据中
      downloadedFileMap: {}, // 已经下载文件列表,key:fileId,value:filePath
      downloadingIds: {}, // id:downloading
      downloadProgress: {}, // id:progress
      isElectron: false,
    };
  },
  filters: {
    // 文件大小
    fileSizeFilter(size, type) {
      if (type === 1) {
        return "-";
      }
      if (size < 1024) {
        return `${size}B`;
      } else if (size < 1024 * 1024) {
        return `${(size / 1024).toFixed(2)}KB`;
      } else if (size < 1024 * 1024 * 1024) {
        return `${(size / (1024 * 1024)).toFixed(2)}MB`;
      } else {
        return `${(size / (1024 * 1024 * 1024)).toFixed(2)}GB`;
      }
    },
  },
  computed: {
    // 文件列表
    currentDownloadedFileMap() {
      const fileList = this.downloadedFileMap[this.getFilePrefix()] || [];
      let res = {};
      fileList.forEach((filePath) => {
        res[filePath] = true;
      });
      return res;
    },
  },
  mounted() {
    this.isElectron = !!window.isElectron;
    console.log("this.isElectron", this.isElectron);
    this.getDownloadedFileList();
    this.getFileList();
    window.addEventListener("scroll", this.scrollFn, true); //监听页面滚动
    window.ipcRenderer?.on("file-download-progress", (event, data) => {
      this.downloadProgress = Object.assign({}, this.downloadProgress, {
        [data.file_id]: Number((data.progress * 100).toFixed(2)),
      });
    });
    window.ipcRenderer?.on("file-download-done", this.fileDownLoadDone);
    window.ipcRenderer?.on("open-file-err", (event, data) => {
      this.$message.info(data.message);
    });
  },
  beforeDestroy() {
    window.ipcRenderer?.off("file-download-done", this.fileDownLoadDone);
    window.removeEventListener("scroll", this.scrollFn, true); //销毁滚动事件
  },
  methods: {
    fileDownLoadDone(event, data) {
      console.log("file-download-done", data);
      if (!data.completed) {
        this.$message.error("下载失败");
      }
      this.downloadingIds = Object.assign({}, this.downloadingIds, {
        [data.file_id]: false,
      });
      this.downloadProgress = Object.assign({}, this.downloadProgress, {
        [data.file_id]: data.completed ? 100 : 0,
      });
      this.getDownloadedFileList();
    },
    scrollFn() {
      if (this.loading) return false;
      //获取网页的总高度
      var htmlHeight =
        document.body.scrollHeight || document.documentElement.scrollHeight;
      //clientHeight是网页在浏览器中的可视高度
      var clientHeight =
        document.body.clientHeight || document.documentElement.clientHeight;
      //scrollTop是浏览器滚动条的top位置
      var scrollTop =
        document.body.scrollTop || document.documentElement.scrollTop;
      //判断到底部了
      if (scrollTop + clientHeight > htmlHeight - 100) {
        if (!this.noMore) {
          this.loading = true;
          this.pageInfo.page++;
          this.getFileList();
        }
      }
    },
    thumbnail(row) {
      if (row.storage_type === 1) {
        return this.folderPic;
      } else {
        if ([".doc", ".docx"].includes(row.file_ext.toLowerCase())) {
          return this.docPic;
        } else if ([".pdf"].includes(row.file_ext.toLowerCase())) {
          return this.pdfPic;
        } else if ([".ppt", ".pptx"].includes(row.file_ext.toLowerCase())) {
          return this.pptPic;
        } else if ([".xlsx", ".xls"].includes(row.file_ext.toLowerCase())) {
          return this.xlsPic;
        } else if ([".txt"].includes(row.file_ext.toLowerCase())) {
          return this.txtPic;
        } else {
          return this.txtPic;
        }
      }
    },
    search() {
      this.resetData();
    },
    reset() {
      this.pageInfo.page = 1;
      this.currentFolder = { id: 0, name: "课程文件" };
      this.searchName = "";
      this.resetData();
    },
    getFileList() {
      this.loading = true;
      getFileList({
        page_no: this.pageInfo.page,
        page_size: this.pageInfo.pageSize,
        course_id: this.$route.params.id,
        name: this.searchName,
        pid: this.currentFolder.id,
      })
        .then((res) => {
          this.loading = false;
          const { code, data, message } = res;
          if (code === 1) {
            this.fileList = [...this.fileList, ...(data.list || [])];
            if (this.fileList.length === res.data.total) {
              this.noMore = true;
            }
          } else {
            this.$message.error(message);
          }
        })
        .catch(() => {
          this.loading = false;
        });
    },
    getDownloadedFileList() {
      this.downloadedFileMap = {};
      if (window.isElectron) {
        const dirPath = this.getFilePrefix();
        const files = window.getFileListByDir({ dirPath: dirPath });
        this.downloadedFileMap[dirPath] = files;
      }
    },
    goBack(val, index) {
      this.levelPath = this.levelPath.splice(0, index + 1);
      this.currentFolder = this.levelPath[index];
      this.resetData();
    },
    downloadElectron(item) {
      const filePath = this.getFilePath(item);
      // 判断是否已经下载过
      const res = window.fileIsExists({
        fileId: item.id,
        filePath: filePath,
      });
      console.log("fileIsExists", filePath);
      if (res.isExist) {
        this.$message.info("文件已下载");
        return;
      }
      this.downloadingIds = Object.assign({}, this.downloadingIds, {
        [item.id]: true,
      });
      this.downloadProgress = Object.assign({}, this.downloadProgress, {
        [item.id]: 0,
      });
      getFileSts({
        course_id: this.$route.params.id,
        course_file_id: item.id,
      }).then(
        (res) => {
          if (res.code === 1) {
            let file_path = filePath;
            res.data.file_path = file_path;
            res.data.file_id = item.id;
            downloadFile(res.data || {});
          } else {
            this.$message.error(res.message);
          }
        },
        () => {
          this.$message.error("下载失败");
          this.downloadingIds = Object.assign({}, this.downloadingIds, {
            [item.id]: false,
          });
        }
      );
    },
    download(item) {
      getFileSts({
        course_id: this.$route.params.id,
        course_file_id: item.id,
      })
        .then((res) => {
          if (res.code === 1) {
            downloadFile(res.data || {}, item.material_name + item.file_ext);
          } else {
            this.$message.error(res.message);
          }
        })
        .catch(() => {
          this.$message.error("下载失败");
        });
    },
    open(item) {
      this.handleCommand(item, 1);
    },
    handleCommand(item, command) {
      if (command === 1) {
        window.openOrDownloadFile({
          file_path: this.getFilePath(item),
          file_id: item.id,
          openType: 1,
        });
      } else if (command === 2) {
        window.openOrDownloadFile({
          file_path: this.getFilePath(item),
          file_id: item.id,
          openType: 2,
        });
      }
    },
    getFilePath(item) {
      let pathSep = window.pathSep ?? "/";
      let prefix = this.getFilePrefix();
      return `${prefix}${pathSep}${item.material_name}${item.file_ext}`;
    },
    getFilePrefix() {
      let pathSep = window.pathSep ?? "/";
      let dirList = [];
      this.levelPath.forEach((item) => {
        if (item.id !== 0) {
          dirList.push(item.id);
        }
      });
      const courseId = this.$route.params.id;
      let prefix = dirList.join(pathSep);
      return `${window.downLoadDir}${courseId}${
        prefix ? pathSep + prefix : ""
      }`;
    },
    resetData() {
      this.fileList = [];
      this.noMore = false;
      this.pageInfo.page = 1;
      this.getDownloadedFileList();
      this.getFileList();
    },
    nextLevel(item) {
      if (item.storage_type === 1) {
        this.levelPath.push({
          id: item.id,
          name: item.material_name,
        });
        this.currentFolder = {
          id: item.id,
          name: item.material_name,
        };
        this.resetData();
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.search-area {
  margin-top: 3px;
  margin-bottom: 16px;
  display: flex;
  flex-direction: row;
  .el-input {
    margin-right: 20px;
    width: 228px;
    .el-icon-search {
      cursor: pointer;
    }
  }
  ::v-deep .search-input input {
    background: linear-gradient(135deg, #f7fffc 0%, #feffff 47%, #f9fffa 100%);
  }
  ::v-deep .el-input__inner {
    border-radius: 8px;
    height: 30px;
    border: 1px solid rgba($color: $saas-border-color, $alpha: 0.49);
  }
  ::v-deep .el-input__inner::placeholder {
    font-size: 12px;
    color: #888988;
  }
  button {
    width: 52px;
    height: 30px;
    border-radius: 8px;
    font-size: 12px;
    line-height: 17px;
  }
  .serarch-btn {
    background: linear-gradient(132deg, #00eb81 0%, #00c89d 100%);
    margin-right: 6px;
    font-weight: 500;
    color: #ffffff;
  }
  .reset-btn {
    border: 1px solid #efefef;
    font-weight: 400;
    color: #747573;
  }
}
.list {
  min-height: 400px;
}
.breadcrumb-box {
  display: flex;
  align-items: center;
  margin-bottom: 16px;
  .separate {
    color: #efefef;
    font-size: 10px;
    margin: 0 6px 0 0;
  }
  .breadcrumb-item {
    cursor: pointer;
    font-weight: 400;
    font-size: 12px;
    color: #515350;
    line-height: 17px;
  }
}
.file-item {
  margin-bottom: 24px;
  height: 37px;
  display: flex;
  align-items: center;
  cursor: pointer;
  .img-box {
    width: 34px;
    height: 34px;
    img {
      width: 100%;
      height: 100%;
      object-fit: cover;
      margin: auto;
    }
  }
  .info-box {
    flex: 1;
    margin-left: 8px;
    height: 100%;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    .name {
      font-weight: 500;
      font-size: 14px;
      color: $saas-text-color;
      line-height: 20px;
    }
    .other-info {
      font-weight: 400;
      font-size: 12px;
      color: #747573;
      line-height: 17px;
    }
    .divider {
      display: inline-block;
      width: 1px;
      height: 6px;
      background: #efefef;
      border-radius: 1px;
      margin: 0 4px 0 8px;
    }
  }
}
.download-btn {
  width: 52px;
  height: 30px;
  background: linear-gradient(132deg, #00eb81 0%, #00c89d 100%);
  border-radius: 8px;
  font-weight: 500;
  font-size: 12px;
  color: #ffffff;
  border: none;
}
::v-deep .open-file-dropdown {
  .el-button--primary,
  .el-button--primary:hover,
  .el-button--primary:focus {
    height: 30px;
    background: linear-gradient(132deg, #00eb81 0%, #00c89d 100%) !important;
    font-weight: 500;
    font-size: 12px;
    color: #ffffff;
    border: none !important;
  }
  .el-button--primary:first-child {
    border-radius: 8px 0 0 8px;
  }
  .el-button--primary:last-child {
    border-radius: 0 8px 8px 0;
  }
}
</style>
